export default {
  path: '',
  component: () => import(`@/page/distributor/component/basic-layout/1.0.4/index.vue`),
  children: [
    {
      path: '/distributor/tour/front/details',
      name: 'distributor-tour-front-details',
      component: () => import('./index.vue'),
      meta: {
        // skip_check_token: true,
      }
    },
  ]
};
